<style>
.bh-table-responsive {
    min-height: 30vh;
}

.list-group-item2 {
    position: relative;
    /* display: block; */
    padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
    color: var(--bs-list-group-color);
    text-decoration: none;
    background-color: var(--bs-list-group-bg);
    border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
</style>
<template>
    <div class="app-layout">
        <!-- Componente de la barra de navegación -->
        <NavBar :collapsed="collapsed" :pinned="pinned" @update:collapsed="updateCollapsed"
            @update:pinned="updatePinned" />
        <!-- Contenido principal -->

        <main :class="{ 'main-collapsed': collapsed, 'main-expanded': !collapsed || pinned }">
            <BarTop />
            <div class="pt-2 px-3">
                <div class="py-4">
                    <h2 class="">Pago a proveedores</h2>
                    <p>Estos pagos son los realizados a aduanas, navieras y administradores varios para efectuar los
                        despachos.
                        Se utilizan para calcular cuánto se le cobrará al cliente final y para crear las notas de cobro.
                    </p>
                    <p>
                        Esta tabla incluye el monto impago actual y los datos del último abono recibido.
                    </p>

                    <div class="text-end">
                        <a class="btn btn-success" href="pagoProveedores/crear">Agregar pago a proveedor</a>
                    </div>
                </div>
                <p>Filtros</p>
                <div class="m-3 row">
                    <div class="col-md-2 mb-4">
                        <label for="rut" class="form-label">Rut cliente</label>
                        <input type="text" class="form-control" :class="{ 'border-danger': dataForm.rut.err }" id="rut"
                            @input="handleRutInput" placeholder="Use solo números y guión" v-model="dataForm.rut.value">
                        <span v-if="dataForm.rut.err" class="text-danger">Debe ingresar un
                            rut</span>
                    </div>
                    <div class="col-md-2 mb-4">
                        <label for="shipping_number" class="form-label">Nro despacho</label>
                        <input type="text" class="form-control"
                            :class="{ 'border-danger': dataForm.shipping_number.err }" id="shipping_number"
                            placeholder="" v-model="dataForm.shipping_number.value">
                        <span v-if="dataForm.shipping_number.err" class="text-danger">Debe ingresar un
                            número de despacho</span>
                    </div>
                    <div class="col-md-2 mb-4">
                        <label for="bill_number" class="form-label">Nro nota cobro</label>
                        <input type="text" class="form-control" :class="{ 'border-danger': dataForm.bill_number.err }"
                            id="bill_number" placeholder="" v-model="dataForm.bill_number.value">
                        <span v-if="dataForm.bill_number.err" class="text-danger">Debe ingresar un
                            número de nota cobro</span>
                    </div>
                    <div class="col-md-2 mb-4">
                        <label for="amount" class="form-label">Monto</label>
                        <input type="text" class="form-control" :class="{ 'border-danger': dataForm.amount.err }"
                            id="amount" placeholder="" v-model="dataForm.amount.value">
                        <span v-if="dataForm.amount.err" class="text-danger">Debe ingresar un monto</span>
                    </div>

                    <div class="col-md-2 mt-4">
                        <div>
                            <a class="btn btn-success" @click="abrirModalClientes()">Seleccionar clientes</a>

                        </div>
                        <span v-if="filtrandoClientes" class="text-danger">Filtro por clientes activado</span>
                    </div>


                    <div class="col-md-2 mt-4">
                        <div class="text-end">
                            <span class="mx-1">
                                <a class="btn btn-success" @click="filter()">Filtrar</a>
                            </span>
                            <a class="btn btn-success" @click="deleteFilters()">Limpiar filtros</a>

                        </div>
                    </div>
                </div>
                <div>
                    <vue3-datatable :no-data-content="'No se encontraron resultados.'" :search="search" :rows="items"
                        :columns="columns" :sortable="true" :sort-column="sortColumn" :sort-direction="sortDirection"
                        :is-server-mode="true" :page="page" :page-size="perPage" :total-rows="totalRows"
                        :loading="loading" @change="onTableChange">
                        <template #amount="data">
                            <span>{{ data.value.amount > 0 ? formatCurrency(data.value.amount,
            data.value.initials) : 0 }}</span>

                        </template>
                        <template #payment_method="data">
                            <span>{{ data.value.payment_method }} </span>
                        </template>
                        <template #value_payment="data">

                            <span>{{ data.value.value_payment > 0 ?
            formatCurrency(data.value.value_payment,
                data.value.value_payment_initials) : 0 }}</span>
                        </template>
                        <template #unpaid_amount="data">
                            <span>{{ data.value.unpaid_amount > 0 ?
            formatCurrency(data.value.unpaid_amount,
                data.value.value_unpaid_initials) : 0 }}</span>
                        </template>
                        <template #rut="row">
                            <td style=" text-align: end; white-space: nowrap;">{{ row.value.rut }}</td>
                        </template>
                        <!-- Celda personalizada -->
                        <!--  <template #last_date_change="row">
                            <td style=" text-align: end; white-space: nowrap;">{{ row.value.last_date_change }}</td>
                        </template> -->
                        <template #actions="data">
                            <div class="text-center">

                                <div>
                                    <div class="dropdown">

                                        <button class="btn btn-secondary dropdown-toggle" type="button"
                                            data-bs-toggle="dropdown" aria-expanded="false">
                                            Acciones
                                        </button>
                                        <ul class="dropdown-menu">
                                            <li @click="showSupp(data.value)"><a class="dropdown-item" href="#"> <i
                                                        class="bi bi-eye px-2"></i>Ver</a></li>
                                            <!--
                                            <li v-if="data.value.unpaid_amount > 0"
                                                @click="addPartialPayment(data.value)"><a class="dropdown-item"
                                                    href="#"> <i class="bi bi-plus-circle px-2"></i>Abonar</a></li>
                                            -->
                                            <li @click="editPayment(data.value)"><a class="dropdown-item" href="#"> <i
                                                        class="bi bi-plus-circle px-2"></i>Editar</a></li>
                                            <li @click="showHistorial(data.value.id_payment);"><a class="dropdown-item"
                                                    href="#"> <i class="bi bi-card-list px-2"></i>Historial</a></li>

                                        </ul>
                                    </div>
                                </div>
                            </div>


                        </template>
                    </vue3-datatable>
                </div>
            </div>
        </main>
        <!-- Historial-->
        <!-- Historial -->
        <div class="modal-mb" v-if="verHistorial">
            <div class="modal-dialo bg-white">
                <div class="modal-content">
                    <div class="modal-header row">
                        <h5 class="modal-title text-black col-11" id="exampleModalLabel">Historial de pagos</h5>
                        <button type="button" class="btn-close col" data-bs-dismiss="modal" @click="closeModal()"
                            aria-label="Cerrar"></button>
                    </div>
                    <div class="modal-body mt-4">
                        <div class="card">
                            <div class="row mx-4">
                                <div class="col-md-2 mb-4">
                                    <label for="historialType" class="form-label">Tipo</label>
                                    <select class="form-select" placeholder="Seleccione un tipo"
                                        aria-label="Seleccione un tipo" v-model="historialType">
                                        <option value="">Ver todos</option>
                                        <option :value="2">Pago a proveedor</option>
                                        <option :value="4">Pago a proveedor (abono directo)</option>
                                        <option :value="3">Pago a proveedor (abono por provisión)</option>
                                    </select>
                                </div>
                                <div class="col-md-2 mt-4">
                                    <div class="text-end">
                                        <a class="btn btn-success" @click="filterHistory()">Filtrar</a>
                                    </div>
                                </div>
                            </div>
                            <div class="">
                                <vue3-datatable :noDataContent="'No se encontraron resultados.'" :search="search"
                                    :rows="payments" :columns="columns2" order :sortable="true">
                                    <template #amount="data">
                                        <span>{{ data.value.amount > 0 ?
            formatCurrency(data.value.amount,
                data.value.initials) : 0 }}</span>
                                    </template>

                                    <template #value_payment="data">
                                        <span>{{ data.value.value_payment > 0 ?
            formatCurrency(data.value.value_payment,
                data.value.value_payment_initials) : 0 }}</span>

                                    </template>

                                    <template #unpaid_amount="data">

                                        <span>{{ data.value.unpaid_amount > 0 ?
            formatCurrency(data.value.unpaid_amount,
                data.value.value_unpaid_initials) : 0 }}</span>

                                    </template>
                                    <template #rut="row">
                                        <td style="text-align: end; white-space: nowrap;">{{ row.value.rut }}</td>
                                    </template>
                                    <!-- Celda personalizada -->
                                    <template #date="row">
                                        <td style="text-align: end; white-space: nowrap;">{{ row.value.date }}</td>
                                    </template>
                                    <template #select="data">
                                        <button @click="toggleSelectionBoard(data.value)">
                                            {{ isSelectedBoard(data.value) ? 'Desasociar' : 'Asociar' }}
                                        </button>
                                    </template>
                                </vue3-datatable>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer mt-3">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                            @click="closeModal()">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Ver -->
        <div class="modal-mb" v-if="verModal">
            <div class="modal-dialo bg-white">
                <div class="modal-content">
                    <div class="modal-header row">
                        <h5 class="modal-title text-black col-11" id="exampleModalLabel">Pago a proveedor</h5>
                        <button type="button" class="btn-close col" data-bs-dismiss="modal" @click="closeModal2()"
                            aria-label="Cerrar"></button>
                    </div>
                    <div class="modal-body mt-4">
                        <div class="card p-4">
                            <div class="row">
                                <div class="col-md-4">
                                    <b>Identificador</b>
                                    <p>{{ supplierPayment.id_payment }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b>Número de despacho</b>
                                    <p>{{ supplierPayment.shipping_number }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b>Estado</b>
                                    <p>{{ supplierPayment.status_name }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b>Fecha de creación</b>
                                    <p>{{ supplierPayment.date_origin }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b>RUT cliente</b>
                                    <p>{{ supplierPayment.rut }}</p>
                                </div>
                                <br>
                                <div class="col-md-4">
                                    <b>Monto deuda original</b>
                                    <p>{{ supplierPayment.amount > 0 ?
            formatCurrency(supplierPayment.amount,
                supplierPayment.initials) : 0 }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b>Monto deuda abonado</b>
                                    <p>{{ supplierPayment.value_payment > 0 ?
            formatCurrency(supplierPayment.value_payment,
                supplierPayment.value_payment_initials) : 0 }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b>Monto impago</b>
                                    <p>{{ supplierPayment.unpaid_amount > 0 ?
            formatCurrency(supplierPayment.unpaid_amount,
                supplierPayment.value_unpaid_initials) :
            0 }}</p>
                                </div>

                                <div class="col-md-4">
                                    <b>Contenedores</b>
                                    <p>{{ supplierPayment.container_number }}</p>
                                </div>

                                <div class="col-md-4">
                                    <b></b>
                                    <p>
                                        <button v-if="supplierPayment.id_status == 5" type="button"
                                            class="btn btn-secondary" data-bs-dismiss="modal"
                                            @click="loadModalDoc(supplierPayment.id_balance)">Ver
                                            archivo pdf</button>
                                        <PreviewFile v-if="showModal" :blob="fileBlob" :mimeType="fileMimeType"
                                            :visible="showModal" @close="showModal = false" />

                                    </p>
                                </div>

                            </div>
                            <br>
                            <br>
                            <h6 v-if="supplierPayment.bank_account_origin">DATOS DE PAGO EFECTUADO AL MOMENTO DE ABONAR
                            </h6>
                            <br>
                            <div class="row">
                                <div class="col-md-4">
                                    <b>Banco</b>
                                    <p>{{ supplierPayment.bank }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b>Método de pago</b>
                                    <p>{{ supplierPayment.payment_method == 1 ? 'Transferencia electrónica' : '' }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b>Número de cuenta</b>
                                    <p>{{ supplierPayment.bank_account_origin }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer mt-3">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                            @click="closeModal2()">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>


        <!-- Seleccionar clientes para filtrado-->
        <div class="modal-mb " v-if="verClientes">
            <div class="modal-dialo bg-white col-md-6 mb-8">
                <div class="modal-content ">
                    <div class="modal-header row ">
                        <h5 class="modal-title text-black col-11" id="exampleModalLabel">Clientes</h5>
                        <button type="button" class="btn-close col" data-bs-dismiss="modal"
                            @click="closeModalClientes()" aria-label="Close"></button>
                    </div>
                    <div class="modal-body mt-4 ">
                        <div class="card">
                            <div>
                                <vue3-datatable :noDataContent="'No se encontraron resultados.'" :search="search"
                                    :rows="clients" :columns="col_clients" order :sortable="true" :sortColumn="'date'"
                                    :sortDirection="'desc'" v-if="renderComponent">
                                    <template #id_client="data">
                                        <div>
                                            <span>{{ data.value.id_client }}</span>
                                        </div>
                                    </template>
                                    <template #name="data">
                                        <div>
                                            <span>{{ data.value.name }}</span>
                                        </div>
                                    </template>
                                    <template #rut="data">
                                        <div>
                                            <span>{{ data.value.rut }}</span>
                                        </div>
                                    </template>
                                    <template #filtrar="data">
                                        <div>
                                            <input type="checkbox" :key="[data.value.id_client] + 'chk'"
                                                :id="[data.value.id_client] + 'chk'" v-model="data.value.filtrar"
                                                @click="toogleFiltraCliente($event, data.value)" />

                                        </div>
                                    </template>


                                </vue3-datatable>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer mt-3">
                        <div class="me-2">
                            <a class="btn btn-success" @click="closeFilterModalClientes()">Filtrar</a>
                        </div>

                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                            @click="closeModalClientes()">Cerrar</button>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import NavBar from './../component/NavBar.vue';
import BarTop from './../component/BarTop.vue';
import PreviewFile from './../component/PreviewFile.vue';
import Vue3Datatable from "@bhplugin/vue3-datatable";


export default {
    components: {
        VueDatePicker,
        Vue3Datatable,
        NavBar,
        PreviewFile,
        BarTop
    },
    data() {
        return {
            loading: false,
            search: '',
            page: 1,
            perPage: 20,
            totalRows: 0,
            sortColumn: 'date_origin',   // campo por defecto que soporte tu API
            sortDirection: 'desc',
            /********* variables para cargar el documento comprobante ********* */
            showModal: false, // para abrir el modal para ver el comprobante 
            fileBlob: null, // el documento pdf encodeado
            fileMimeType: null, // el tipo de documento (podría no ser realmente un pdf)
            lastBalanceLoaded: 0, // id del último balance descargado
            /******************************************************************* */
            renderComponent: true,
            collapsed: true,
            verHistorial: false,
            historialType: '',
            idHistory: 0,
            verModal: false,
            supplierPayment: {},
            pinned: localStorage.getItem('pinned') == 'false' ? false : true || false,
            theme: localStorage.getItem('theme') || 'light-mode',
            options: {
                responsive: true,
                maintainAspectRatio: false,
            },
            payments: [],
            items: [],
            clients: [],
            old_clients: [],
            verClientes: false,
            filtrandoClientes: false,
            // estas son columnas son de la tabla 
            // para filtrar por clientes múltiple
            col_clients: [
                { field: "id_client", title: "ID", filter: false },
                { field: "name", title: "Nombre" },
                { field: "rut", title: "RUT" },
                { field: "filtrar", title: 'Filtrar', sortable: false }
            ],
            dataForm: {
                rut: {
                    value: '',
                    err: false,
                    msjErr: ''
                },
                shipping_number: {
                    value: '',
                    err: false,
                    msjErr: ''
                },
                bill_number: {
                    value: '',
                    err: false,
                    msjErr: ''
                },
                amount: {
                    value: 0,
                    err: false,
                    msjErr: ''
                },
            },
            // estas son las columnas de la tabla de
            // ver Historial
            columns2: [
                { field: "id_payment_balance", title: "ID" },
                { field: "shipping_number", title: "Nro. de despacho" },
                { field: "date", title: "Fecha" },
                { field: "week_number", title: "Número de semana" },
                { field: "table_type", title: "Tipo" },
                { field: "id_billing_note", title: "Nota de cobro" },
                { field: "rut", title: "RUT cliente" },
                { field: "status_name", title: "Estado" },
                { field: "concept", title: "Concepto" },
                { field: "amount", title: "Monto de deuda original" },
                { field: "value_payment", title: "Monto abonado" },
                { field: "exchange_rate", title: "Tasa de cambio" },
                { field: "unpaid_amount", title: "Monto impago" },
                { field: "bank_account_origin", title: "Cuenta de origen" },
                { field: "bank", title: "Banco" },
                { field: "payment_method", title: "Método de pago" },
            ],
            // Estas son las columnas de la tabla principal
            columns: [
                { field: "id_payment", title: "ID" },
                { field: "shipping_number", title: "Nro. de despacho" },
                { field: "date_origin", title: "Fecha" },
                { field: "week_number_origin", title: "Número de semana" },
                { field: "booking_number", title: "Número de reserva" },
                { field: "id_billing_note", title: "Notas de cobro asociadas" },
                { field: "rut", title: "RUT cliente" },
                { field: "status_name", title: "Estado" },
                { field: "concept", title: "Concepto" },
                { field: "amount", title: "Monto de deuda original" },
                { field: "value_payment", title: "Último monto abonado" },
                { field: "date", title: "Fecha último abono" },
                { field: "unpaid_amount", title: "Monto impago actual" },
                { field: "actions", title: "" },
            ],

        }
    },
    async mounted() {
        await this.getSP();
        await this.getClients();
        this.$swal.close();
        document.body.className = this.theme;
    },
    computed: {

    },
    methods: {
        onTableChange(payload) {
            this.page = Number(payload.current_page ?? payload.page ?? this.page) || 1;
            this.perPage = Number(payload.pagesize ?? payload.pageSize ?? this.perPage) || this.perPage;
            this.sortColumn = payload.sort_column ?? payload.sortColumn ?? this.sortColumn;
            this.sortDirection = payload.sort_direction ?? payload.sortDirection ?? this.sortDirection;
            this.filter(); // vuelve a pedir datos con los nuevos parámetros
        },
        filter() {
            this.loading = true;

            const params = {
                page: this.page,
                per_page: this.perPage,
                rut: this.dataForm.rut.value,
                nroDespacho: this.dataForm.shipping_number.value,
                bill_number: this.dataForm.bill_number.value,
                monto: this.dataForm.amount.value,
                clientes: this.getClientesFiltrados(),
                sort_by: this.sortColumn,
                sort_dir: this.sortDirection,
            };

            axios.post('/api/getLastPayments', params, {
                headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
            })
                .then(({ data, status }) => {
                    if (status === 200) {
                        this.items = data.data || [];
                        this.totalRows = Number(data.total ?? 0);
                        if (data.per_page) this.perPage = Number(data.per_page);        // opcional
                        if (data.current_page) this.page = Number(data.current_page);    // opcional
                    } else {
                        this.items = [];
                        this.totalRows = 0;
                    }
                })
                .catch(err => {
                    if (err.response?.statusText === 'Unauthorized') {
                        localStorage.removeItem('accessToken');
                        window.location.href = './../../api/auth/logout';
                    }
                })
                .finally(() => {
                    this.loading = false;
                    this.$swal?.close?.();
                });
        },

        async getSP() {
            this.$swal({ title: 'Obteniendo pago a proveedores' });
            this.$swal.showLoading();
            this.loading = true;

            const params = {
                page: this.page,
                per_page: this.perPage,
                rut: this.dataForm.rut.value,
                nroDespacho: this.dataForm.shipping_number.value,
                monto: this.dataForm.amount.value,
                bill_number: this.dataForm.bill_number.value,
                clientes: this.getClientesFiltrados(),
                sort_by: this.sortColumn,
                sort_dir: this.sortDirection,
            };

            try {
                const { data, status } = await axios.post('/api/getLastPayments', params, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
                });

                if (status === 200) {
                    this.items = data.data || [];
                    this.totalRows = Number(data.total ?? 0);
                    if (data.per_page) this.perPage = Number(data.per_page);
                    if (data.current_page) this.page = Number(data.current_page);
                } else {
                    this.items = [];
                    this.totalRows = 0;
                }
            } catch (err) {
                if (err.response?.statusText === 'Unauthorized') {
                    localStorage.removeItem('accessToken');
                    window.location.href = './../../api/auth/logout';
                }
            } finally {
                this.loading = false;
                this.$swal.close();
            }
        },
        async forceRerender() {
            // función para forzar VUE a actualizar un elemento,
            // necesaria para las checkbox de selección de cliente (filtro)

            // Remove MyComponent from the DOM
            this.renderComponent = false;

            // Wait for the change to get flushed to the DOM
            await this.$nextTick();

            // Add the component back in
            this.renderComponent = true;
        },


        closeModal() {
            this.verHistorial = false;
        },
        showSupp(value) {
            this.verModal = true;
            this.supplierPayment = value;
        },
        closeModal2() {
            this.verModal = false;
        },
        formatCurrency(value, currencyCode = 'CLP') {
            return new Intl.NumberFormat('es-CL', {
                style: 'currency',
                currency: currencyCode,
                minimumFractionDigits: 0 // O puedes cambiar el valor según lo que necesites
            }).format(value);
        },
        updateCollapsed(value) {
            //console.log('Evento recibido:', value); // Para depuración
            this.collapsed = value; // Actualiza el estado
        },
        updatePinned(value) {
            //  console.log('Evento recibido pinn:', value); // Para depuración
            this.pinned = value; // Actualiza el estado
        },
        showreq(id) {
            const self = this;

        },
        toggleDropdown(data) {
            this.$swal({
                title: "Seleccione una accion",
                text: 'puedes generar una nota de cobro o abonar este pago',
                icon: "question",
                showDenyButton: true,
                showCancelButton: true,
                confirmButtonText: "Abonar",
                denyButtonText: `Generar nota de cobro`
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    this.addPartialPayment(data);//abonar
                } else if (result.isDenied) {
                    this.createBill(data);//emitir nota de cobro
                }
            });
        },
        async filterHistory() {
            let id = this.idHistory;
            let self = this;
            self.verHistorial = false;
            this.$swal({
                title: 'Obteniendo historial de abonos'
            });
            this.$swal.showLoading();
            try {
                let params = {
                    tipo: this.historialType
                }
                const response = await axios.post('/api/getLastPaymentsHistory/' + id, params, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                    }
                });
                if (response) {
                    this.$swal.close();
                    self.verHistorial = true;
                }
                self.payments = response.data.data;
            } catch (error) {
                console.error('Error fetching concepts:', error);
            }
        },
        async showHistorial(id) {
            this.idHistory = id;
            this.historialType = '';
            let params = {
                tipo: this.historialType
            }
            try {
                const response = await axios.post('/api/getLastPaymentsHistory/' + id, params, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                    }
                });

                this.verHistorial = true;
                this.payments = response.data.data;
            } catch (error) {
                console.error('Error fetching concepts:', error);
            }

        },

        editPayment(data) {
            window.location.href = '/pagoProveedores/crear/' + data.id_payment;
        },


        addPartialPayment(data) {

            console.dir(data);

            let showBtn = true;
            let nota = "";
            if (data.emitted_notes == "") {
                showBtn = false;
                nota = "Pago sin nota de cobro emitida, ";
                nota += " abonos directos deshabilitados.";
            }

            this.$swal({
                title: "¿Deseas abonar este pago?",
                text: nota,
                showDenyButton: true,
                showCancelButton: true,
                showConfirmButton: showBtn,
                confirmButtonText: "Abonar",
                cancelButtonText: 'Cancelar',
                denyButtonText: `Abonar desde provisiones`
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    window.location.href = 'pagoProveedores/abonar/' + data.id_payment + '/' + data.id_client;
                } else if (result.isDenied) {
                    this.getSupply(data)

                }
            });

        },
        async getSupply(data) {
            const self = this;
            try {
                const response = await axios.get('/api/clientSupply/' + data.id_client, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                    }
                });
                let supply = response.data; // Array de objetos con el campo "amount"

                // Suma de todos los amounts (asegurándonos de que sean numéricos)
                let totalAmount = supply.reduce((acc, item) => {
                    return acc + Number(item.amount);
                }, 0);

                if (totalAmount > 0) {
                    // Redirige si la suma es mayor que 0
                    window.location.href = 'pagoProveedores/provisionabonar/'
                        + data.id_payment + '/' + data.id_client;
                } else {
                    // Muestra mensaje si no hay saldo
                    this.$swal.fire({
                        icon: 'info',
                        title: 'Sin saldo disponible',
                        text: 'No cuentas con saldo en tus provisiones',
                        confirmButtonText: 'OK'
                    });
                }

            } catch (error) {
                console.error('Error fetching supply:', error);
            }
        },
        getClientesFiltrados() {
            let self = this;
            let filtrados = self.clients.filter((client) => client.filtrar == true);

            let ids_clientes = filtrados.map((client) => {
                return client.id_client;
            });
            return ids_clientes;
        },

        async toogleFiltraCliente(event, clientData) {
            clientData.filtrar = !clientData.filtrar;
            this.forceRerender(); // checkbox no se actualiza sin esto
            // console.log(this.getClientesFiltrados());
        },

        closeModalClientes() {
            // cerrar cancelando cambios
            this.clients = this.old_clients;
            if (this.getClientesFiltrados().length > 0) {
                this.filtrandoClientes = true;
            } else {
                this.filtrandoClientes = false;
            }
            this.verClientes = false;
        },

        closeFilterModalClientes() {
            // cerrar y filtrar
            this.old_clients = this.clients;
            if (this.getClientesFiltrados().length > 0) {
                this.filtrandoClientes = true;
            } else {
                this.filtrandoClientes = false;
            }
            this.verClientes = false;
            this.filter();
        },

        abrirModalClientes() {
            this.verClientes = true;
            // esto funciona solo cuando a js se le da la gana
            //this.old_clients = structuredClone(this.clients);

            // guarda versión anterior
            this.old_clients = this.clients.map((clientData) => {
                var clientdata = {
                    "id_client": clientData.id_client,
                    "rut": clientData.rut,
                    "filtrar": structuredClone(clientData.filtrar),
                    "name": clientData.name
                };
                return clientdata;
            });
        },

        /* formatea mientras escribe y sólo agrega el guion final */
        handleRutInput(e) {
            // 1. quitar caracteres no permitidos y pasar a mayúsculas
            const raw = e.target.value.replace(/[^0-9kK]/g, '').toUpperCase();

            // 2. si aún no hay suficiente largo, mostrar tal cual
            if (raw.length <= 1) {
                this.dataForm.rut.value = raw;
                this.dataForm.rut.err = false;
                return;
            }

            // 3. separar cuerpo y dígito verificador
            const cuerpo = raw.slice(0, -1);
            const dv = raw.slice(-1);

            // 4. concatenar con guion (sin puntos)
            this.dataForm.rut.value = `${cuerpo}-${dv}`;
            this.dataForm.rut.err = false;   // limpia error mientras escribe
        },


        formatRut(rut, withDots) {
            let parts = rut.split('-');
            let nums = parts[0].replaceAll('.', '');
            if (withDots) {
                let rutnum = new Intl.NumberFormat('es-CL').format(nums);
                return rutnum + "-" + parts[1];
            } else {
                return nums + "-" + parts[1];
            }
        },

        async getClients() {
            this.$swal({
                title: 'Obteniendo clientes',
            });
            this.$swal.showLoading();

            const self = this;

            await axios.get('/api/clients', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                }
            }).then(response => {

                if (response.status == 200) {

                    self.clients = response.data.map((clientData) => {
                        // guardamos solo los campos importantes
                        var clientdata = {
                            "id_client": clientData.id_client,
                            "rut": self.formatRut(clientData.rut, true),
                            "filtrar": false,
                            "name": clientData.name
                        };
                        return clientdata;
                    });

                    //self.clientesSelect = response.data.clienteEmpresa;
                    // cerramos el sweet alert en mount
                    // this.$swal.close();
                } else {
                    self.clients = [];
                }
            }).catch(function (error) {
                console.log(error);
                if (error.response && error.response.statusText === "Unauthorized") {
                    localStorage.removeItem('accessToken');
                    window.location.href = './../../api/auth/logout'
                }
            });
        },

        base64ToBlob(base64, contentType, sliceSize = 512) {
            const byteCharacters = atob(base64);
            const byteArrays = [];

            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                const slice = byteCharacters.slice(offset, offset + sliceSize);
                const byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
            }

            return new Blob(byteArrays, { type: contentType });
        },

        async loadModalDoc(id_balance) {

            const self = this;

            if (self.lastBalanceLoaded == id_balance) {
                // nada nuevo que descargar

                self.showModal = true;
                return
            }

            // console.log("pdf ver");

            /*this.$swal({
               title: 'Obteniendo documento...',
            });
            this.$swal.showLoading();*/

            let params = {
                id_payment_balance: id_balance
            }

            await axios.post('/api/get-linked-payment-doc', params, {
                headers: {
                    // 'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                }
            }).then(response => {
                // console.log(response.data);
                if (response.status == 200) {

                    //self.fileBlob =  this.base64ToBlob(response.data['file'], 
                    //                                    response.data['mime_type'],  512);
                    // self.fileBlob =  response.data['file'] ;
                    // self.fileBlob =  new Blob(response.data['file'], { type: response.data['mime_type'] });
                    let thefile = response.data.data['file'];
                    let themime = response.data.data['mime_type'];
                    self.fileBlob = this.base64ToBlob(thefile,
                        themime, 512);
                    self.filename = response.data.data['filename'];
                    self.fileMimeType = response.data.data['mime_type'];
                    self.lastBalanceLoaded = response.data.data['id_payment_balance'];
                    self.showModal = true;

                    //console.log(response);
                    //this.$swal.close();
                } else {
                    //self.items = [];
                }
            }).catch(function (error) {
                console.log(error);
                if (error.response && error.response.statusText === "Unauthorized") {
                    localStorage.removeItem('accessToken');
                    window.location.href = './../../api/auth/logout'
                }
            });
        },

        async delFiltroClientes() {
            this.clients = this.clients.map((clientData) => {
                clientData.filtrar = false;
                return clientData;
            });
            this.old_clients = this.old_clients.map((clientData) => {
                clientData.filtrar = false;
                return clientData;
            });

            this.filtrandoClientes = false;
        },

        async deleteFilters() {
            this.dataForm.bill_number.value = '';
            this.dataForm.shipping_number.value = '';
            this.dataForm.rut.value = '';
            this.dataForm.amount.value = 0;

            ['bill_number', 'shipping_number', 'rut', 'amount'].forEach(id => {
                const el = document.getElementById(id);
                if (el) el.value = id === 'amount' ? '0' : '';
            });

            await this.delFiltroClientes();
            this.page = 1;
            this.filter();
        }


    },
};
</script>

<style lang="css">
@import 'bootstrap';
@import 'datatables.net-bs5';



.cont-proveedor {
    height: 300px;
    overflow-y: scroll;
}
</style>